import { useV2WhoAmIQuery, V2MeResource } from "@generated";

type Privileges = NonNullable<V2MeResource["attributes"]["privileges"]>;
export type AccessLevel = NonNullable<Privileges[number]["access-level"]>;

const usePrivilegeCheck = () => {
  const { data: user, isLoading, isError } = useV2WhoAmIQuery();

  const privileges: Privileges = user?.data?.attributes?.privileges ?? [];

  // The user's access level for a privilege, or undefined when /me hasn't
  // loaded or doesn't list it. For pages that pass the level down as a prop.
  const accessLevel = (privilegeName: string): AccessLevel | undefined =>
    privileges.find((privilege) => privilege.privilege === privilegeName)?.[
      "access-level"
    ];

  const hasPrivilege = (
    requiredPrivilege: string,
    requiredAccessLevels: string[]
  ): boolean => {
    return privileges.some((privilege) => {
      if (!privilege["access-level"]) return false;

      return (
        privilege.privilege === requiredPrivilege &&
        requiredAccessLevels.includes(privilege["access-level"])
      );
    });
  };

  return {
    hasPrivilege,
    accessLevel,
    privilegesLoading: isLoading,
    isError,
    user,
  };
};

export default usePrivilegeCheck;
